var render, staticRenderFns
import script from "./adsetproto.vue?vue&type=script&lang=js&"
export * from "./adsetproto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c9a6014c', component.options)
    } else {
      api.reload('c9a6014c', component.options)
    }
    
  }
}
component.options.__file = "src/components/services/adsetproto.vue"
export default component.exports